import { ReactNode } from 'react';

type Variant = 'success' | 'warning' | 'error' | 'info' | 'default';

const VARIANT_CLASSES: Record<Variant, string> = {
  success: 'bg-success-light text-success',
  warning: 'bg-warning-light text-warning',
  error: 'bg-error-light text-error',
  info: 'bg-surface-info text-brand-vivid',
  default: 'bg-bg-surface-raised text-text-muted',
};

interface Props {
  children: ReactNode;
  variant?: Variant;
}

const Badge = ({ children, variant = 'default' }: Props) => (
  <span
    className={`inline-flex items-center text-xs font-semibold px-2.5 py-1 rounded-full ${VARIANT_CLASSES[variant]}`}
  >
    {children}
  </span>
);

export default Badge;
